import "./App.css";
import React, { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Menu from "./Containers/Menu/Menu";
import Home from "./Containers/Home/Home";
import Orders from "./Containers/Orders/Orders";
import AdminMenu from "./Containers/AdminMenu/AdminMenu";
import NewFood from "./Containers/NewFood/NewFood";
import Login from "./Containers/Login/Login";
import AlertContext from "./utils/alertContext";
import TokenContext from "./utils/tokenContext";
import NewUser from "./Containers/NewUser/NewUser";
import axios from "axios";
import UserLog from "./Containers/UserLog/UserLog";
import Queue from "./Containers/Queue/Queue";
import ProtectedRoute from "./utils/ProtectedRoute";
import OrderCompleted from "./Containers/OrderCompleted/OrderCompleted";

function App() {
  const [alert, setAlert] = useState({ message: "", type: "" });
  const [token, setToken] = useState("");
  const [loading, setLoading] = useState(false);

  axios.defaults.baseURL =
    "https://us-central1-jtnail-app.cloudfunctions.net/api";

  useEffect(() => {
    const getJwt = async () => {
      try {
        const item = window.localStorage.getItem("idToken");
        setToken(item);
      } catch (err) {
        console.log(err);
      } finally {
        setLoading(false);
      }
    };
    if (!token) {
      getJwt();
    }
  }, [token]);

  // const login = (token, cb) => {
  //   setToken(token);
  //   cb();
  // };

  // const logout = (cb) => {
  //   setToken("");
  //   cb();
  // }

  if (loading) return null;

  return (
    <BrowserRouter>
      <AlertContext.Provider value={{ ...alert, setAlert: setAlert }}>
        <TokenContext.Provider value={{ token: token, setToken: setToken }}>
          <Routes>
            <Route
              path="/admin/orders"
              element={
                <ProtectedRoute>
                  <Orders />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/completed"
              element={
                <ProtectedRoute>
                  <OrderCompleted />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/menu"
              element={
                <ProtectedRoute>
                  <AdminMenu />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/menu/add"
              element={
                <ProtectedRoute>
                  <NewFood />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/menu/update/:id"
              element={
                <ProtectedRoute>
                  <NewFood />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/create-user"
              element={
                <ProtectedRoute>
                  <NewUser />
                </ProtectedRoute>
              }
            />
            <Route path="/queue" element={<Queue />} />
            <Route path="/login" element={<Login />} />
            <Route path="/:id" element={<Menu />} />
            <Route path="/services" element={<Home />} />
            <Route path="/" element={<UserLog />} />
          </Routes>
        </TokenContext.Provider>
      </AlertContext.Provider>
    </BrowserRouter>
  );
}

export default App;
